<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>投标书列表</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right" @click="goBack()">
                <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>

        <div>
            <table class="custom-tbl" v-if="callBidDocStatus==4">
                <thead class="head">
                <tr class="row">
                    <th width="">招标标题</th>
                    <th width="200">投标方</th>
                    <th width="">投标时间</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="bidDoc in bidDocList">
                    <td>{{bidDoc.title}}</td>
                    <td>{{bidDoc.merchantName}}</td>
                    <td>{{bidDoc.bidTime}}</td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="callBidDocStatus==5">
                <thead class="head">
                <tr class="row">
                    <th width="">招标标题</th>
                    <th width="200">投标方</th>
                    <th width="200">投标时间</th>
                    <th width="100">分数</th>
                    <th width="200">评标人</th>
                    <th width="200">评标时间</th>
                    <th width="120">是否中标</th>
                    <th width="200">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="bidDoc in bidDocList">
                    <td>{{bidDoc.title}}</td>
                    <td>{{bidDoc.merchantName}}</td>
                    <td>{{bidDoc.bidTime}}</td>
                    <td>{{bidDoc.evalScore}}</td>
                    <td>{{bidDoc.evaluatorName}}</td>
                    <td>{{bidDoc.evalTime}}</td>
                    <td v-if="bidDoc.resultFlag==1">是</td>
                    <td v-if="bidDoc.resultFlag==-1">否</td>
                    <td v-if="bidDoc.resultFlag==0">初始</td>
                    <td>
                        <div v-if="bidDoc.resultFlag==0">
                            <a class="swb-btn-link" @click="toSwbBidDocInfo(bidDoc.id)">查看</a>
                            <a class="swb-btn-link" @click="toEvalScore(bidDoc.id)">评分</a>
                            <a v-if="bidParityIds.indexOf(bidDoc.id) < 0" class="swb-btn-link" @click="addBidParity(bidDoc)">加入比价</a>
                            <a class="swb-btn-link font-gray" v-else>加入比价</a>
                            <a class="swb-btn-link" @click="addQualifiedMerchant(bidDoc.merchantId, bidDoc.merchantType)">加入备选供方</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="callBidDocStatus==6">
                <thead class="head">
                <tr class="row">
                    <th width="">招标标题</th>
                    <th width="200">投标方</th>
                    <th width="200">投标时间</th>
                    <th width="100">分数</th>
                    <th width="200">评标人</th>
                    <th width="200">评标时间</th>
                    <th width="120">是否中标</th>
                    <th width="200">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="bidDoc in bidDocList">
                    <td>{{bidDoc.title}}</td>
                    <td>{{bidDoc.merchantName}}</td>
                    <td>{{bidDoc.bidTime}}</td>
                    <td>{{bidDoc.evalScore}}</td>
                    <td>{{bidDoc.evaluatorName}}</td>
                    <td>{{bidDoc.evalTime}}</td>
                    <td v-if="bidDoc.resultFlag==1">是</td>
                    <td v-if="bidDoc.resultFlag==-1">否</td>
                    <td v-if="bidDoc.resultFlag==0">初始</td>
                    <td>
                        <div>
                            <a class="swb-btn-link" v-if="bidDoc.resultFlag==0" @click="setResultFlagForYes(bidDoc.id)">中标</a>
                            <a class="swb-btn-link" v-if="bidDoc.resultFlag==0" @click="setResultFlagForNo(bidDoc.id)">未中标</a>
                            <a v-if="bidParityIds.indexOf(bidDoc.id) < 0" class="swb-btn-link" @click="addBidParity(bidDoc)">加入比价</a>
                            <a class="swb-btn-link font-gray" v-else>加入比价</a>
                            <a class="swb-btn-link" @click="toSwbBidDocInfo(bidDoc.id)">查看</a>
                            <a class="swb-btn-link" @click="addQualifiedMerchant(bidDoc.merchantId, bidDoc.merchantType)">加入备选供方</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="callBidDocStatus==7">
                <thead class="head">
                <tr class="row">
                    <th class="align-left" width="">招标标题</th>
                    <th width="200">投标方</th>
                    <th width="200">投标时间</th>
                    <th width="100">分数</th>
                    <th class="align-left" width="200">评标人</th>
                    <th width="200">评标时间</th>
                    <th width="120">是否中标</th>
                    <th width="200">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="bidDoc in bidDocList">
                    <td class="align-left">{{bidDoc.title}}</td>
                    <td>{{bidDoc.merchantName}}</td>
                    <td>{{bidDoc.bidTime}}</td>
                    <td>{{bidDoc.evalScore}}</td>
                    <td class="align-left">{{bidDoc.evaluatorName}}</td>
                    <td>{{bidDoc.evalTime}}</td>
                    <td v-if="bidDoc.resultFlag==1">是</td>
                    <td v-if="bidDoc.resultFlag==-1">否</td>
                    <td v-if="bidDoc.resultFlag==0">初始</td>
                    <td>
                        <a v-if="bidParityIds.indexOf(bidDoc.id) < 0" class="swb-btn-link" @click="addBidParity(bidDoc)">加入比价</a>
                        <a class="swb-btn-link font-gray" v-else>加入比价</a>
                        <a class="swb-btn-link" @click="toSwbBidDocInfo(bidDoc.id)">查看</a>
                        <a class="swb-btn-link" @click="addQualifiedMerchant(bidDoc.merchantId, bidDoc.merchantType)">加入备选供方</a>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
        <div class="pagination-layout mt10">
            <el-pagination background class="pagination-layout mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
        <div style="margin-top: 300px;">
            <swb-bid-parity-center :callBidDocId="callBidDocId" @notity-syncRefresh="syncRefreshBidParity($event)" ref="swb_bid_parity_center"></swb-bid-parity-center>
        </div>
    </div>
</template>

<script>
    import { Utils, Store } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'
    //
    import tendBidApi from '../../api/tendBid'
    import merchtComnApi from '../../api/merchtComn'

    import SwbBidDocInfo from './BidDocInfo';
    Routes.add(SwbBidDocInfo);

    import SwbCallBidDocList from './CallBidDocList';
    Routes.add(SwbCallBidDocList);

    import SwbParityCenter from './ParityCenter.vue';
    Vue.regist(SwbParityCenter);

    function getStore() {
        if(typeof Store != 'undefined') {
            return Store;
        } else {
            console.warn('请确保引入了 store.js');
        }
        //
        return null;
    }

    export default{
        name: 'swb-bid-doc-list',
        path: '/tend/bid/doc/list',
        pathOld: '/bid/doc/list/to',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '投标书列表',
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                bidDocList: [],
                userInfo: null,
                callBidDocStatus: null,
                checkedTime: false,
                bidParityKey: "bidParityKey",
                bidParityIds: [],
                callBidDocId: null
            }
        },
        created: function () {
            this.callBidDocId = this.$route.query.callDocId || null;
            this.pageSize = this.pageSizes.first();
            //
            this.callBidDocStatus = this.$route.query.type;
            //
            let closeTime = this.$route.query.closeTime;
            this.checkedTime = this.checkTime(closeTime);
            this.getBidParityIds();
            this.getBidDocList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getBidDocList();
            },
            getBidDocList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                filterItems.callDocId = this.$route.query.callDocId;
                filterItems.auditState = 1;//getEnumInfoWith('auditState', 'name', 'AuditPass');     // 需要改变成枚举值..........
                var sort_createTime = "createTime" + ":" + "DESC";
                var sort_resultFlag = "resultFlag" + ":" + "DESC";
                let sortItemList = [sort_createTime, sort_resultFlag];
                postData.sortItemList = sortItemList;
                postData.filterItems = filterItems;
                let lastMsgBoxDlg = MsgBox.loading();
                tendBidApi.getBidDocList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        self.bidDocList = result.data.rows;
                        let bidDocList = self.bidDocList;
                        // 设置定标操作是否显示
                        for(let i = 0; i < bidDocList.length; i++) {
                            let resultFalg = bidDocList[i].resultFlag;
                            if(resultFalg == 1) {
                                self.resultFalg = false;
                                break;
                            }
                        }
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            toSwbBidDocInfo: function (id) {
                this.$router.push({
                    path: SwbBidDocInfo.path,
                    query: {
                        bidDocId: id
                    }
                });
            },
            // 评分
            toEvalScore: function (bidDocId) {
                let self = this;
                this.$prompt('请输入分数', '评分', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^[0-9]*$/,
                    inputErrorMessage: '请输入正整数',
                }).then(({value}) => {
                    if(!Utils.isNoB(value)) {
                        let postData = {};
                        postData.id = bidDocId;
                        postData.evalScore = value;
                        let theLoad = MsgBox.loading();
                        tendBidApi.updateBidDocEvaluated(postData, function (result) {
                            if(result.type == 'info') {
                                MsgBox.success('评分成功');
                                self.getBidDocList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                            theLoad.hide();
                        });
                    } else {
                        MsgBox.warning('请输入分数');
                    }
                }).catch(() => {
                });
            },
            // 中标
            setResultFlagForYes: function (id) {
                let self = this;
                this.$confirm('是否已发预中标公告且无异议 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    postData.resultFlag = 1; // 修改给 枚举值...
                    let theLoad = MsgBox.loading();
                    tendBidApi.updateBidDocResultFlag(postData, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('成功');
                            self.getBidDocList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                        theLoad.hide();
                    });
                });
            },
            // 未中标
            setResultFlagForNo: function (id) {
                let self = this;
                this.$confirm('是否确定不中标 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    postData.resultFlag = -1; // 修改给 枚举值...
                    let theLoad = MsgBox.loading();
                    tendBidApi.updateBidDocResultFlag(postData, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('成功');
                            self.getBidDocList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                        theLoad.hide();
                    });
                });
            },

            checkTime: function (time) {
                var currTime = new Date();
                var dbTime = new Date(time);

                if(currTime.getTime() >= dbTime.getTime()) {
                    return true;
                } else if(currTime.getTime() < dbTime.getTime()) {
                    return false;
                }
            },
            // 加入合格商户
            addQualifiedMerchant: function (merchantId, merchantType) {
                // 为了使用原有的接口，设置数据
                let peerMerchantIds = [];
                peerMerchantIds.add(merchantId);
                //
                let postData = {};
                postData.bizRelIds = peerMerchantIds;
                postData.peerMerchantType = merchantType;
                let lastMsgBoxDlg = MsgBox.loading();
                merchtComnApi.saveMerchantBizRel(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result != null) {
                        if(result.type == 'info') {
                            MsgBox.success(result.message);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    }
                });
            },
            goBack: function () {
                let self = this;
                let checkState = this.$route.query.checkState;
                this.$router.push({
                    path: SwbCallBidDocList.path,
                    query: {
                        checkState: checkState,
                    }
                });
            },
            getBidParityIds: function () {
                let callDocId = this.$route.query.callDocId;
                let bidParityIds = [];
                //
                let store = getStore() || {};
                let bidParityList = store.get(this.bidParityKey) || [];
                if(bidParityList != null && bidParityList.length > 0) {
                    let bidFirst = bidParityList[0];
                    if(bidFirst.callDocId == callDocId) {
                        for(let i = 0; i < bidParityList.length; i++) {
                            let bidItem = bidParityList[i];
                            bidParityIds.push(bidItem.id);
                        }
                    }
                }
                this.bidParityIds = bidParityIds;
            },
            addBidParity: function (item) {
                let store = getStore() || {};
                let bidParityList = store.get(this.bidParityKey) || [];
                if(bidParityList != null && bidParityList.length > 0) {
                    //
                    let bidFirst = bidParityList[0];
                    if(bidFirst.callDocId != item.callDocId) {
                        bidParityList = [];
                    }
                    for(let i = 0; i < bidParityList.length; i++) {
                        let bidItem = bidParityList[i];
                        if(bidItem.id == item.id) {
                            MsgBox.warning("已加入比价！");
                            store.set(this.bidParityKey, bidParityList);
                            return;
                        }
                    }
                    //
                    if(bidParityList.length >= 10) {
                        MsgBox.warning("最多可添加10个！");
                        return;
                    }
                    bidParityList.push(item);
                } else {
                    bidParityList.push(item);
                }
                MsgBox.success("加入成功！");
                store.set(this.bidParityKey, bidParityList);
                this.getBidParityIds();
                this.$refs.swb_bid_parity_center.getBidParityList();
            },
            syncRefreshBidParity: function (isTrue) {
                this.getBidParityIds();
            }
        }
    }

</script>




// WEBPACK FOOTER //
// src/compo/callbid/BidDocList.vue